import React, {useEffect, useState} from "react"
import {FormControl, FormLabel} from "@chakra-ui/react"

import {QuestionField} from "@backend/types"
import {gameApiCalls} from "@modules/game/service"
import {Loading} from "@components/app"

type AirtableImportProps = {
    onImport: (props: AirtableImportType) => void
}

type Field = { id: string, name: string }

type Table = {
    id: string,
    name: string,
    views?: Field[],
    fields?: Field[]
}

type State = {
    bases: Field[]
    baseId?: string
    tables?: Table[]
    tableId?: string,
    selectedTable?: Table
}

export type AirtableImportType = {
    headers: { id: string, name: string }[],
    selectedHeaders?: QuestionField[],
    records: any[]
}

export function AirtableImport({onImport}: AirtableImportProps) {
    const [data, setData] = useState<State | null>()

    useEffect(() => {

        gameApiCalls.airtable().then(result => {
            setData({
                bases: result
            })
        })
    }, [])

    function onBaseSelect(baseId: string) {
        gameApiCalls.airtable(baseId)
            .then(result => {
                setData(prevState => ({
                    ...prevState,
                    tables: result,
                    baseId
                }))
            })
    }

    function onTableSelect(tableId: string) {
        const {tables} = data

        const table = tables.find(x => x.id === tableId)
        if (table) {
            setData(prevState => ({
                ...prevState,
                tableId,
                selectedTable: table
            }))
        }
    }

    function onViewSelect(viewId: string) {
        const {baseId, tableId, selectedTable} = data
        const view = selectedTable.views.find(x => x.id === viewId)
        console.log("view", view)

        gameApiCalls.airtableRecords(baseId, tableId, view.id).then(records => {

            const rVal = records.map(record => Object.keys(record.fields).reduce((acc, key) => {

                if (Array.isArray(record.fields[key]))
                    acc[key] = record.fields[key].length > 0 ? record.fields[key][0] : null
                else
                    acc[key] = record.fields[key]

                return acc
            }, {}))
            console.log(rVal)
            onImport({
                headers: selectedTable.fields,
                selectedHeaders: [],
                records: rVal
            })
        })


    }

    if (!data)
        return <Loading/>


    return <div className="grid grid-cols-2 gap-4">
        <FormControl className="col-span-1">
            <FormLabel htmlFor="base">Base</FormLabel>
            <select
                id="base"
                onChange={(e) => {
                    if (e.target.value)
                        onBaseSelect(e.target.value)
                }}
                className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
                <option key="" value=""></option>
                {data.bases.map(({id, name}) => <option key={id} value={id}>{name}</option>)}
            </select>
        </FormControl>

        <FormControl className="col-span-1">
            <FormLabel htmlFor="table">Table</FormLabel>
            <select
                id="table"
                onChange={(e) => {
                    if (e.target.value) {
                        onTableSelect(e.target.value)
                    }
                }}
                className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
                <option key="" value=""></option>
                {(data.tables || []).map(({id, name}) => <option key={id} value={id}>{name}</option>)}
            </select>
        </FormControl>

        <FormControl className="col-span-1">
            <FormLabel htmlFor="view">View</FormLabel>
            <select
                id="view"
                onChange={(e) => {
                    if (e.target.value) {
                        onViewSelect(e.target.value)
                    }
                }}

                className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
                <option key="" value=""></option>
                {((data.selectedTable || {}).views || []).map(({id, name}) => <option key={id}
                                                                                      value={id}>{name}</option>)}
            </select>
        </FormControl>

    </div>
}